import { render, staticRenderFns } from "./RateHelpdesk.vue?vue&type=template&id=c7e68a40&"
import script from "./RateHelpdesk.vue?vue&type=script&lang=js&"
export * from "./RateHelpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VRating})
